<template>
  <div>
    <el-dialog
      title="产品资料"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
      width="1350px"
      v-dialogDrag
      @close="close"
    >
      <div class="handle_class">
        <div style="width: 70%">
          <el-tabs v-model="activeName" type="card">
            <el-tab-pane label="基础资料" name="first">
              <el-divider content-position="left">基础资料</el-divider>
              <el-table
                :show-header="false"
                :data="tabelData"
                border
                :cell-style="columnStyle"
              >
                <el-table-column prop="name" align="center"></el-table-column>
                <el-table-column
                  prop="amount1"
                  align="center"
                ></el-table-column>
                <el-table-column
                  prop="amount2"
                  align="center"
                ></el-table-column>
                <el-table-column prop="amount3" align="center">
                </el-table-column>
              </el-table>
            </el-tab-pane>
          </el-tabs>
        </div>
        <div style="width: 29%; margin-top: 55px; margin-left: 15px">
          <el-divider content-position="left">产品图片</el-divider>
          <el-link v-if="!isMore" type="primary" @click="more()"
            >查看更多<i class="el-icon-more"></i>
          </el-link>
          <el-link v-if="isMore" type="primary" @click="more()"
            >收回<i class="el-icon-more"></i>
          </el-link>
          <viewer :images="ImgList">
            <img
              v-for="(src, index) in ImgList"
              :src="src"
              :key="index"
              width="180"
            />
          </viewer>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
/**
 * 产品资料查看弹窗组件
 * 功能：按 SKU 调用 getProductList 接口，展示产品基础资料表格（云羿/易佰 SKU、名称、包装、成本、时间等 12 行）与产品图片（可展开全部）
 */
import { getProductList } from "@/api/user";
export default {
  name: "look",
  props: {
    scope: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      // 当前激活的 Tab 名称
      activeName: "first",
      // 是否已展开全部图片
      isMore: false,
      // 基础资料表格数据
      tabelData: [],
      // 当前展示的产品图片列表
      ImgList: [],
      // 产品全部图片列表
      allImgList: [],
      // 切分后的图片列表（当前未使用）
      sliceImfList: [],
      // 弹窗显示状态
      dialogFormVisible: true,
      // 产品详情数据
      dataObj: {},
      // 后端返回的下拉字典数据
      renderList: {},
    };
  },
  created() {
    // 组件创建时加载产品详情
    this.handleClick();
  },
  methods: {
    /** 打开弹窗时加载产品详情数据 */
    handleClick() {
      this.getDateil();
    },
    // 自定义列背景色
    columnStyle({ row, column, rowIndex, columnIndex }) {
      if (columnIndex % 2 == 0) {
        //第三第四列的背景色就改变了2和3都是列数的下标
        return "background:#f3f6fc;";
      } else {
        return "background:#ffffff;";
      }
    },
    /** 关闭弹窗并通知父组件 */
    close() {
      this.$emit("isShowEdit");
    },
    /**
     * 按 SKU 查询产品详情并回填表格与图片
     */
    getDateil() {
      let param = {
        sku: this.scope.sku,
      };
      getProductList(param)
        .then((result) => {
          if (result.code == 200) {
            Object.assign(this.dataObj, result.data.pageInfo);
            Object.assign(this.renderList, result.data.renderList);
            let img = "";
            if (this.dataObj.noLogo == "[]") {
              if (this.dataObj.assistantImg == "[]") {
                img = this.dataObj.uploadimgs;
              } else {
                img = this.dataObj.assistantImg;
              }
            } else {
              img = this.dataObj.noLogo;
            }
            this.allImgList = JSON.parse(
              JSON.stringify(eval("(" + this.dataObj.assistantImg + ")"))
            );
            let imgObj = eval("(" + img + ")");
            this.ImgList = imgObj.slice(0, 4);
            this.dialogFormVisible = true;
            this.getTableData();
          }
        })
        .catch((err) => {});
    },
    /** 切换产品图片展开全部或收回（图片超过 4 张时生效） */
    more() {
      if (this.allImgList.length <= 4) {
        let list = JSON.parse(JSON.stringify(this.allImgList));
      } else {
        if (this.isMore) {
          this.isMore = false;
          let list = JSON.parse(JSON.stringify(this.allImgList));
          this.ImgList = list.slice(0, 4);
        } else {
          this.isMore = true;
          this.ImgList = JSON.parse(JSON.stringify(this.allImgList));
        }
      }
    },
    /** 组装产品基础资料表格数据（云羿SKU、易佰SKU、名称、包装、成本、时间等 12 行） */
    getTableData() {
      let param = {
        name: "云羿SKU",
        amount1: this.dataObj.sku,
        amount2: "",
        amount3: "",
      };
      this.tabelData.push(param);
      let param1 = {
        name: "易佰SKU",
        amount1: this.dataObj.goodsSn,
        amount2: "产品状态",
        amount3: this.$getText(this.dataObj.status, this.renderList.status),
      };
      this.tabelData.push(param1);
      let param2 = {
        name: "中文名称",
        amount1: this.dataObj.titleCn,
        amount2: "英文名称",
        amount3: this.dataObj.titleEn,
      };
      this.tabelData.push(param2);
      let param3 = {
        name: "产品类别",
        amount1: this.dataObj.productType,
        amount2: "产品线",
        amount3: this.dataObj.productName,
      };
      this.tabelData.push(param3);

      let param4 = {
        name: "毛重（g）",
        amount1: this.dataObj.grossProductWeight,
        amount2: "产品净重（g）",
        amount3: this.dataObj.productWeight,
      };
      this.tabelData.push(param4);
      let param5 = {
        name: "产品尺寸",
        amount1:
          this.dataObj.productLength +
          "*" +
          this.dataObj.productWidth +
          "*" +
          this.dataObj.productHeight,
        amount2: "装箱尺寸",
        amount3:
          this.dataObj.fullContainerLength +
          "*" +
          this.dataObj.fullContainerWidth +
          "*" +
          this.dataObj.fullContainerHeight,
      };
      this.tabelData.push(param5);
      let param6 = {
        name: "包装尺寸",
        amount1:
          this.dataObj.packProductLength +
          "*" +
          this.dataObj.packProductWidth +
          "*" +
          this.dataObj.packProductHeight,
        amount2: "是否带原包装",
        amount3: this.$getText(
          this.dataObj.productPackageCodeNew,
          this.renderList.productOriginalPackage
        ),
      };
      this.tabelData.push(param6);

      let param7 = {
        name: "发货包装",
        amount1: this.$getText(
          this.dataObj.productPackageCodeNew,
          this.renderList.productPackageCodeNew
        ),
        amount2: "发货包材",
        amount3: "",
      };
      this.tabelData.push(param7);
      let param8 = {
        name: "采购来货包装",
        amount1: this.$getText(
          this.dataObj.productToWayPackage,
          this.renderList.productToWayPackage
        ),
        amount2: "贴标加工包装",
        amount3: this.dataObj.productLabelProces,
      };
      this.tabelData.push(param8);
      let param9 = {
        name: "包装类型",
        amount1: this.$getText(
          this.dataObj.packageTypes,
          this.renderList.packageTypes
        ),
        amount2: "是否带说明书",
        amount3: this.$getText(
          this.dataObj.instructions,
          this.renderList.instructions
        ),
      };
      this.tabelData.push(param9);
      let param10 = {
        name: "是否多属性",
        amount1: this.$getText(
          this.dataObj.productIsMulti,
          this.renderList.productIsMulti
        ),
        amount2: "是否新品",
        amount3: this.$getText(
          this.dataObj.productIsNew,
          this.renderList.productIsNew
        ),
      };
      this.tabelData.push(param10);
      let param11 = {
        name: "平均采购成本（RMB）",
        amount1: this.dataObj.avgPrice,
        amount2: "最近采购成本（RMB）",
        amount3: this.dataObj.newPrice,
      };
      this.tabelData.push(param11);
      let param12 = {
        name: "创建时间",
        amount1: this.dataObj.createTime,
        amount2: "修改时间",
        amount3: this.dataObj.modifyTime,
      };
      this.tabelData.push(param12);
    },
  },
};
</script>